<!-- no template tag -->
<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
    name: 'UiLineChart',
    extends: Line,
    mixins: [reactiveProp],
    props: {
        options: {
            type: Object,
            default: function () {
                return null;
            }
        },
        noData: {
            type: Object,
            default: function () {
                return {
                    text: '表示するデータがありません',
                    size: 18,
                };
            },
            validator: function (value) {
                return typeof value.text !== 'undefined'
                    && (typeof value.text === 'string' || value.text instanceof String)
                    && (typeof value.size === 'undefined' || (
                        Number.isInteger(value.size)
                        && value.size > -1
                    ))
                ;
            },
        },
    },
    computed: {
        hasData: function () {
            return this.chartData.datasets.some(dataset => dataset.data.length > 0);
        },
        computedOptions: function () {
            if (this.hasData) return this.options;
            return Object.assign({}, this.options, {
                legend: {display:false},
                scales: {
                    xAxes: [{
                        gridLines: {display: false},
                        ticks: {display: false},
                    }],
                    yAxes: [{
                        gridLines: {display: false},
                        ticks: {display: false},
                    }],
                }
            });
        },
    },
    watch: {
        computedOptions: {
            handler (newOptions, oldOptions) {
                this.$data._chart.destroy();
                this.renderChart(this.chartData, newOptions);
            },
            deep: true
        },
    },
    mounted: function () {
        this.addPlugin({
            afterDraw: function (chart) { // draw no data text
                if (!this.hasData) {
                    let ctx = chart.ctx;

                    let fontText = this.noData.text;
                    let defaultFont = Chart.defaults.global;
                    let fontSize = this.noData.size || defaultFont.defaultFontSize;
                    let fontColor = defaultFont.defaultFontColor;
                    let fontFamily = defaultFont.defaultFontFamily;
                    let fontStyle = defaultFont.defaultFontStyle;

                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillStyle = fontColor;
                    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                    ctx.fillText(fontText, chart.width / 2, chart.height / 2);
                }
            }.bind(this)
        });
        this.renderChart(this.chartData, this.computedOptions);
    },
}
</script>
